import { useRouterStore, userStore, useUserStore } from "../store";
import { getToken } from "../api";
import router from "../config/routes";
import { ElNotification } from "element-plus";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

const whiteList = ["/login", "/register"];

/** 页面枚举 */
enum PageEnum {
  // basic login path
  BASE_LOGIN = "/login",
  // basic home path
  BASE_HOME = "/settle",

  // 
  BASE_INDEX = '/'
}

export const initMainRouter = async () => {

  if (getToken()) {
    const _routesStore = useRouterStore();
    const _userStore = useUserStore();

    const [routers] = await Promise.all([
      _routesStore.getRouter(),
      _userStore.getUser(),
    ]);

    /** 挂载路由，并得到对应卸载路由的函数 */
    const removeRoutes: Function[] = [];
    routers.map((route) => {
      removeRoutes.push(router.addRoute(route));
    });

    _routesStore.removeRoutes = removeRoutes;
    return routers
  } else {
    return []
  }


}

router.beforeEach(async (to, from) => {

  NProgress.start();
  const _routesStore = useRouterStore();
  const _userStore = useUserStore();
  // 检查用户是否已登录 & 避免无限重定向
  if (!getToken() && to.path !== PageEnum.BASE_LOGIN) {
    if (!whiteList.includes(to.path)) {
      // 否则全部重定向到登录页
      ElNotification({
        title: "通知",
        message: "请登录系统",
        type: "info",
      });
    }
    // 将用户重定向到登录页面
    return PageEnum.BASE_LOGIN;
  } else if (getToken() && !_routesStore.removeRoutes.length) {
    try {
      const routers = await initMainRouter()
      /** 可在此处根据不同的系统或角色进行首页定向 */
      const path =
        from.path === PageEnum.BASE_LOGIN ? routers[0].path : to.path;

      return { ...to, path, replace: true };
    } catch (error) {
      console.log(error);
    }
  }
});

router.afterEach(() => {
  NProgress.done()
})

export default router;
